// /// LoginModal.jsx (updated forgot/reset flow)
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Box,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { Visibility, VisibilityOff, Send } from "@mui/icons-material";
// import CloseIcon from '@mui/icons-material/Close';
// import apiClient from "../api/axiosClient";
// import RegisterModal from "./RegisterModal";

// const PASSWORD_RESET_ENDPOINT = "/auth/password/reset/"; // backend endpoint
// const OTP_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

// const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (open) {
//       const t = setTimeout(() => setVisible(true), 10);
//       const hide = setTimeout(() => {
//         setVisible(false);
//         setTimeout(() => onClose && onClose(), 300);
//       }, 6000);
//       return () => {
//         clearTimeout(t);
//         clearTimeout(hide);
//       };
//     } else {
//       setVisible(false);
//     }
//   }, [open, onClose]);

//   if (!open && !visible) return null;

//   const palette = {
//     success: { bg: "linear-gradient(135deg,#7ee787,#28c76f)", accent: "#0a7a3b", text: "#062b18" },
//     error: { bg: "linear-gradient(135deg,#ff9a9e,#ff6b6b)", accent: "#660000", text: "#3b0f0f" },
//     warning: { bg: "linear-gradient(135deg,#ffd89b,#ffb347)", accent: "#7a4300", text: "#3b2a00" },
//     info: { bg: "linear-gradient(135deg,#a1c4fd,#c2e9fb)", accent: "#174ea6", text: "#07203a" },
//   }[severity] || { bg: "linear-gradient(135deg,#e0e0e0,#bdbdbd)", accent: "#333", text: "#111" };

//   const containerStyle = {
//     position: "fixed",
//     left: "50%",
//     top: "28px",
//     transform: `translateX(-50%) translateY(${visible ? "0" : "18px"})`,
//     opacity: visible ? 1 : 0,
//     transition: "transform 260ms cubic-bezier(.2,.9,.2,1), opacity 260ms ease",
//     zIndex: 1400,
//     minWidth: "260px",
//     maxWidth: "92%",
//     boxShadow: "0 12px 40px rgba(11,22,40,0.28)",
//     borderRadius: "14px",
//     overflow: "hidden",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "12px 16px",
//     background: palette.bg,
//     color: palette.text,
//     fontFamily: "Inter, Roboto, sans-serif",
//     border: `1px solid rgba(255,255,255,0.08)`,
//     backdropFilter: "blur(6px)",
//   };

//   const iconCircle = {
//     width: 42,
//     height: 42,
//     borderRadius: 10,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "rgba(255,255,255,0.12)",
//     flexShrink: 0,
//   };

//   const titleStyle = {
//     fontSize: 13,
//     fontWeight: 700,
//     color: palette.accent,
//     letterSpacing: "0.2px",
//   };

//   const messageStyle = {
//     fontSize: 13,
//     color: palette.text,
//     opacity: 0.95,
//     marginTop: 6,
//     maxWidth: 520,
//     wordBreak: "break-word",
//   };

//   const closeBtnStyle = {
//     marginLeft: "12px",
//     border: "none",
//     background: "transparent",
//     cursor: "pointer",
//     padding: 6,
//     borderRadius: 8,
//     color: "rgba(0,0,0,0.6)",
//   };

//   const titleMap = { success: "Success", error: "Error", warning: "Warning", info: "Info" };

//   return (
//     <div role="status" aria-live="polite" style={containerStyle}>
//       <div style={iconCircle}>
//         <div style={{ fontSize: 18, fontWeight: 700, color: palette.accent }}>
//           {severity === "success" ? "✓" : severity === "error" ? "!" : severity === "warning" ? "!" : "i"}
//         </div>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//         <div style={titleStyle}>{titleMap[severity] || "Notice"}</div>
//         <div style={messageStyle}>{message}</div>
//       </div>

//       <button
//         aria-label="close message"
//         onClick={() => {
//           setVisible(false);
//           setTimeout(() => onClose && onClose(), 260);
//         }}
//         style={closeBtnStyle}
//       >
//         <CloseIcon fontSize="small" />
//       </button>
//     </div>
//   );
// };

// const LoginModal = ({ type, onClose, onLoginSuccess, onRegisterClick }) => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [showRegisterModal, setShowRegisterModal] = useState(false);
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [loading, setLoading] = useState(false);

//   // Forgot password states
//   const [showForgot, setShowForgot] = useState(false);
//   const [fpEmail, setFpEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpValue, setOtpValue] = useState("");
//   const [otpLoading, setOtpLoading] = useState(false);
//   // new: otp verification & timestamps
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [otpGeneratedAt, setOtpGeneratedAt] = useState(null); // ms timestamp when OTP was issued
//   const otpExpiryTimerRef = useRef(null);

//   const [newPassword, setNewPassword] = useState("");
//   const [confirmNewPassword, setConfirmNewPassword] = useState("");

//   // show/hide for reset password fields
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

//   // remember me
//   const [rememberMe, setRememberMe] = useState(false);

//   // Resend timer
//   const [resendTimer, setResendTimer] = useState(0);
//   useEffect(() => {
//     let timer = null;
//     if (resendTimer > 0) {
//       timer = setInterval(() => setResendTimer((t) => Math.max(0, t - 1)), 1000);
//     }
//     return () => clearInterval(timer);
//   }, [resendTimer]);

//   // Snack state
//   const [snack, setSnack] = useState({ open: false, severity: "info", message: "" });
//   const snackTimerRef = useRef(null);

//   const showSnack = useCallback(({ severity = "info", message = "" }) => {
//     if (snackTimerRef.current) {
//       clearTimeout(snackTimerRef.current);
//       snackTimerRef.current = null;
//     }
//     setSnack({ open: true, severity, message });
//     snackTimerRef.current = setTimeout(() => {
//       setSnack((s) => ({ ...s, open: false }));
//       snackTimerRef.current = null;
//     }, 6000);
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (snackTimerRef.current) {
//         clearTimeout(snackTimerRef.current);
//         snackTimerRef.current = null;
//       }
//       if (otpExpiryTimerRef.current) {
//         clearTimeout(otpExpiryTimerRef.current);
//         otpExpiryTimerRef.current = null;
//       }
//     };
//   }, []);

//   // helper to post without auth header
//   const postWithoutAuth = async (url, body) => {
//     try {
//       return await apiClient.post(url, body, { skipAuth: true });
//     } catch (err) {
//       return await apiClient.post(url, body, { headers: { Authorization: undefined } });
//     }
//   };

//   // ---------- Login ----------
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     try {
//       const res = await apiClient.post("/auth/login/", {
//         email: formData.email,
//         password: formData.password,
//       });

//       const { access, refresh } = res.data;
//       if (access) {
//         sessionStorage.setItem("access_token", access);
//         sessionStorage.setItem("refresh_token", refresh || "");
//         sessionStorage.setItem("user_info", JSON.stringify(res.data.user || {}));
//         apiClient.defaults.headers = apiClient.defaults.headers || {};
//         apiClient.defaults.headers.common = apiClient.defaults.headers.common || {};
//         apiClient.defaults.headers.common["Authorization"] = `Bearer ${access}`;
//       }

//       onLoginSuccess(res.data);
//       onClose();
//     } catch (err) {
//       const data = err.response?.data;
//       const status = err.response?.status;

//       if (data && typeof data === "object") {
//         if (data.email) {
//           showSnack({ severity: "error", message: "Your user id / mail id is wrong — please check." });
//           setLoading(false);
//           return;
//         }
//         if (data.password) {
//           showSnack({ severity: "error", message: "Password is wrong for this email — please check." });
//           setLoading(false);
//           return;
//         }
//         const nf = data.non_field_errors || data.detail || data.error || null;
//         if (nf) {
//           const nfString = Array.isArray(nf) ? nf.join(" ") : String(nf);
//           const lower = nfString.toLowerCase();
//           if (lower.includes("unable to log in") || lower.includes("no active account") || lower.includes("invalid credentials") || lower.includes("credentials")) {
//             showSnack({ severity: "error", message: "Email or password is incorrect — please check and try again." });
//             setLoading(false);
//             return;
//           }
//           showSnack({ severity: "error", message: nfString });
//           setLoading(false);
//           return;
//         }
//       }

//       if (status === 401) {
//         showSnack({ severity: "error", message: "Email or password is incorrect — please check and try again." });
//         setLoading(false);
//         return;
//       }

//       const fallback = err.response?.data?.detail || err.message || "Login failed.";
//       showSnack({ severity: "error", message: `Login failed: ${fallback}` });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------- Send OTP ----------
//   const handleSendOtp = async () => {
//     if (!fpEmail) return showSnack({ severity: "warning", message: "Enter your registered email." });
//     setOtpLoading(true);

//     try {
//       // IMPORTANT: include purpose="password_reset" so backend will check user existence
//       const res = await postWithoutAuth("/otp/generate/", { email: fpEmail.trim(), purpose: "password_reset" });

//       // If we reach here, OTP was sent
//       setOtpSent(true);
//       setOtpValue("");
//       setResendTimer(60);
//       const attempts = res.data?.attempts_left;
//       const blocked = res.data?.blocked_until;

//       // set generated timestamp & clear any previous verification
//       setOtpGeneratedAt(Date.now());
//       setOtpVerified(false);
//       if (otpExpiryTimerRef.current) {
//         clearTimeout(otpExpiryTimerRef.current);
//         otpExpiryTimerRef.current = null;
//       }
//       // auto-clear verification after expiry (safety)
//       otpExpiryTimerRef.current = setTimeout(() => {
//         setOtpVerified(false);
//         otpExpiryTimerRef.current = null;
//       }, OTP_EXPIRY_MS);

//       let msg = `OTP sent to ${fpEmail} (expires in 5 minutes)`;
//       if (attempts !== undefined) msg += ` — attempts left: ${attempts}`;
//       if (blocked) msg += ` — blocked until: ${blocked}`;
//       showSnack({ severity: "success", message: msg });
//     } catch (err) {
//       // If backend returned user_not_found (404) — show the requested message
//       const status = err.response?.status;
//       const data = err.response?.data;

//       if (status === 404 && (data?.detail === "user_not_found" || data?.reason === "user_not_found")) {
//         // Show a small pop-up telling user to register first
//         showSnack({ severity: "warning", message: "You have not registered with this email — please register first." });
//         // ensure we don't leave otpSent true
//         setOtpSent(false);
//         setOtpValue("");
//         return;
//       }

//       const msg = friendlyErrorMessage(err);
//       showSnack({ severity: "error", message: `Failed to send OTP: ${msg}` });
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   // Optional: Info-only verify (does not prevent reset)
//   const handleLocalVerifyOtp = async () => {
//     const otp = otpValue.trim();
//     if (!/^\d{6}$/.test(otp)) {
//       return showSnack({ severity: "warning", message: "Enter a 6-digit OTP." });
//     }
//     setOtpLoading(true);
//     try {
//       const res = await postWithoutAuth("/otp/validate/", { email: fpEmail.trim(), otp });

//       // success => mark verified, start clearing timer to match OTP expiry
//       if (res.data?.valid || res.status === 200) {
//         // Ensure we have a generated timestamp; if not, treat as just-verified-now
//         const generatedAt = otpGeneratedAt || Date.now();
//         setOtpGeneratedAt(generatedAt);
//         setOtpVerified(true);

//         // clear any existing expiry timer and schedule verification clear based on original generation time
//         if (otpExpiryTimerRef.current) {
//           clearTimeout(otpExpiryTimerRef.current);
//           otpExpiryTimerRef.current = null;
//         }
//         const elapsed = Date.now() - generatedAt;
//         const remaining = Math.max(0, OTP_EXPIRY_MS - elapsed);
//         if (remaining > 0) {
//           otpExpiryTimerRef.current = setTimeout(() => {
//             setOtpVerified(false);
//             otpExpiryTimerRef.current = null;
//           }, remaining);
//         } else {
//           // already expired
//           setOtpVerified(false);
//           showSnack({ severity: "error", message: "OTP already expired — request a new one." });
//           setOtpLoading(false);
//           return;
//         }

//         showSnack({ severity: "success", message: "OTP verified — you may now reset your password (within 5 minutes)." });
//       } else {
//         showSnack({ severity: "error", message: "OTP validation failed." });
//       }
//     } catch (err) {
//       // if validate consumes the OTP on success, doing a validate may cause reset to fail later.
//       // We only use this as informational. If your backend consumes the OTP on validate, avoid calling this.
//       const data = err.response?.data;
//       const reason = data?.reason || JSON.stringify(data) || err.message;
//       showSnack({ severity: "error", message: `OTP verification failed: ${reason}` });
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   // ---------- Password validation ----------
//   const passwordValidation = (pwd) => {
//     const errors = [];
//     if (!pwd || pwd.length < 6) errors.push("Minimum 6 characters");
//     if (!/\d/.test(pwd)) errors.push("At least one digit required");
//     if (!/[^\w\s]/.test(pwd)) errors.push("At least one special character required");
//     return {
//       valid: errors.length === 0,
//       message: errors.join(", "),
//     };
//   };

//   // ---------- Reset password (direct call to reset endpoint) ----------
//   const handleResetPassword = async () => {
//     const otp = otpValue.trim();
//     if (!fpEmail) return showSnack({ severity: "warning", message: "Enter your registered email." });
//     if (!/^\d{6}$/.test(otp)) return showSnack({ severity: "warning", message: "Enter a 6-digit OTP." });

//     // Enforce verification + expiry check BEFORE calling reset endpoint
//     if (!otpVerified) {
//       return showSnack({ severity: "warning", message: "Please verify the OTP first using 'Verify' button." });
//     }
//     // check expiry relative to generation time
//     if (!otpGeneratedAt || Date.now() - otpGeneratedAt > OTP_EXPIRY_MS) {
//       setOtpVerified(false);
//       return showSnack({ severity: "error", message: "OTP expired or not found. Request a new OTP and try again." });
//     }

//     const validation = passwordValidation(newPassword);
//     if (!validation.valid) {
//       return showSnack({ severity: "warning", message: "Password invalid: " + validation.message });
//     }
//     if (newPassword !== confirmNewPassword) {
//       return showSnack({ severity: "error", message: "Passwords do not match." });
//     }

//     setOtpLoading(true);
//     try {
//       const res = await postWithoutAuth(PASSWORD_RESET_ENDPOINT, {
//         email: fpEmail.trim(),
//         otp,
//         new_password: newPassword,
//       });

//       showSnack({ severity: "success", message: res.data?.detail || "Password reset successful. Please log in." });

//       // reset forgot-password state
//       setShowForgot(false);
//       setFpEmail("");
//       setOtpSent(false);
//       setOtpValue("");
//       setNewPassword("");
//       setConfirmNewPassword("");
//       setResendTimer(0);
//       setOtpVerified(false);
//       setOtpGeneratedAt(null);
//       if (otpExpiryTimerRef.current) {
//         clearTimeout(otpExpiryTimerRef.current);
//         otpExpiryTimerRef.current = null;
//       }
//     } catch (err) {
//       const data = err.response?.data;
//       // helpful message for expired/not found
//       if (data?.reason === "expired_or_not_found" || (typeof data?.detail === "string" && data.detail.toLowerCase().includes("expired"))) {
//         setOtpVerified(false);
//         showSnack({ severity: "error", message: "OTP expired or not found. Request a new OTP and try again." });
//       } else {
//         const msg = friendlyErrorMessage(err, {
//           notFoundHint: `Endpoint not found (404). Ensure backend implements POST ${PASSWORD_RESET_ENDPOINT}`,
//         });
//         showSnack({ severity: "error", message: `Password reset failed: ${msg}` });
//       }
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   function friendlyErrorMessage(err, opts = {}) {
//     const status = err.response?.status;
//     const data = err.response?.data;

//     if (typeof data === "string") {
//       const lower = data.slice(0, 200).toLowerCase();
//       if (lower.includes("<!doctype") || lower.includes("<html")) {
//         if (status === 404 && opts.notFoundHint) return opts.notFoundHint;
//         return `Server returned HTML (status ${status || "unknown"})`;
//       }
//       return data.length > 300 ? data.slice(0, 300) + "..." : data;
//     }

//     if (data?.detail) return data.detail;
//     if (data && typeof data === "object") {
//       try {
//         const keys = Object.keys(data);
//         if (keys.length === 0) return `HTTP ${status || "error"}`;
//         const first = data[keys[0]];
//         if (typeof first === "string") return first;
//         if (Array.isArray(first)) return first.join(" ");
//         return JSON.stringify(first).slice(0, 300) + (JSON.stringify(first).length > 300 ? "..." : "");
//       } catch (e) {
//         return `HTTP ${status || "error"}`;
//       }
//     }

//     return err.message || `HTTP ${status || "error"}`;
//   }

//   return (
//     <>
//       <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
//         <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//           <Typography variant="h6">{type === "admin" ? "Admin Login" : "User Login"}</Typography>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           {!showForgot ? (
//             <Box component="form" onSubmit={handleSubmit} sx={{ display: "grid", gap: 2 }}>
//               <TextField
//                 label="Email Address"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={formData.email}
//                 onChange={(e) => setFormData((p) => ({ ...p, email: e.target.value }))}
//               />

//               <TextField
//                 label="Password"
//                 variant="outlined"
//                 required
//                 type={showPassword ? "text" : "password"}
//                 fullWidth
//                 value={formData.password}
//                 onChange={(e) => setFormData((p) => ({ ...p, password: e.target.value }))}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton onClick={() => setShowPassword((s) => !s)} edge="end">
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                 <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                   <input
//                     type="checkbox"
//                     className="checkbox"
//                     checked={rememberMe}
//                     onChange={(e) => setRememberMe(e.target.checked)}
//                   />
//                   <span style={{ fontSize: 14 }}>Remember me</span>
//                 </label>

//                 <Button
//                   variant="text"
//                   onClick={() => {
//                     setShowForgot(true);
//                     setFpEmail(formData.email || "");
//                   }}
//                 >
//                   Forgot password?
//                 </Button>
//               </Box>

//               <Button
//                 type="submit"
//                 variant="contained"
//                 color={type === "admin" ? "secondary" : "primary"}
//                 disabled={loading}
//                 startIcon={loading ? <CircularProgress size={18} /> : null}
//               >
//                 {loading ? "Signing In..." : "Sign In"}
//               </Button>
//             </Box>
//           ) : (
//             <Box sx={{ display: "grid", gap: 2 }}>
//               <Typography variant="subtitle1">Forgot Password</Typography>

//               <TextField
//                 label="Registered Email"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={fpEmail}
//                 onChange={(e) => {
//                   setFpEmail(e.target.value);
//                   setOtpSent(false);
//                   setOtpValue("");
//                   setOtpVerified(false);
//                   setOtpGeneratedAt(null);
//                   if (otpExpiryTimerRef.current) {
//                     clearTimeout(otpExpiryTimerRef.current);
//                     otpExpiryTimerRef.current = null;
//                   }
//                 }}
//               />

//               <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                 <Button
//                   variant="contained"
//                   onClick={handleSendOtp}
//                   disabled={otpLoading || !fpEmail || resendTimer > 0}
//                   startIcon={otpLoading ? <CircularProgress size={18} /> : <Send />}
//                 >
//                   {resendTimer > 0 ? `Resend in ${resendTimer}s` : otpSent ? "Resend OTP" : "Send OTP"}
//                 </Button>

//                 {otpSent && (
//                   <>
//                     <TextField
//                       label="Enter OTP"
//                       variant="outlined"
//                       value={otpValue}
//                       onChange={(e) => setOtpValue(e.target.value.replace(/\D/g, "").slice(0, 6))}
//                       inputProps={{ maxLength: 6 }}
//                     />
//                     <Button
//                       variant="outlined"
//                       onClick={handleLocalVerifyOtp}
//                       disabled={otpLoading || otpValue.length !== 6}
//                     >
//                       Verify
//                     </Button>
//                   </>
//                 )}
//               </Box>

//               {/* Show new password fields once user entered a 6-digit OTP (so they can set new password right away) */}
//               {otpValue.length === 6 && (
//                 <>
//                   <TextField
//                     label="New Password"
//                     variant="outlined"
//                     required
//                     type={showNewPassword ? "text" : "password"}
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     helperText="Min 6 chars, at least 1 digit and 1 special character"
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton onClick={() => setShowNewPassword((s) => !s)} edge="end">
//                             {showNewPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                   <TextField
//                     label="Confirm New Password"
//                     variant="outlined"
//                     required
//                     type={showConfirmNewPassword ? "text" : "password"}
//                     value={confirmNewPassword}
//                     onChange={(e) => setConfirmNewPassword(e.target.value)}
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton onClick={() => setShowConfirmNewPassword((s) => !s)} edge="end">
//                             {showConfirmNewPassword ? <VisibilityOff /> : <Visibility />}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />

//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <Button variant="contained" onClick={handleResetPassword} disabled={otpLoading}>
//                       {otpLoading ? <CircularProgress size={18} /> : "Reset Password"}
//                     </Button>
//                     <Button
//                       variant="text"
//                       color="inherit"
//                       onClick={() => {
//                         setShowForgot(false);
//                         setFpEmail("");
//                         setOtpSent(false);
//                         setOtpValue("");
//                         setNewPassword("");
//                         setConfirmNewPassword("");
//                         setResendTimer(0);
//                         setOtpVerified(false);
//                         setOtpGeneratedAt(null);
//                         if (otpExpiryTimerRef.current) {
//                           clearTimeout(otpExpiryTimerRef.current);
//                           otpExpiryTimerRef.current = null;
//                         }
//                       }}
//                     >
//                       Cancel
//                     </Button>
//                   </Box>

//                   {/* small verification status indicator (non-invasive) */}
//                   <Box sx={{ mt: 1 }}>
//                     <Typography variant="caption" sx={{ display: "block" }}>
//                       {otpVerified ? "OTP verified (valid for 5 minutes from send time)." : "OTP not yet verified. Click Verify."}
//                     </Typography>
//                   </Box>
//                 </>
//               )}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, py: 2 }}>
//           {!showForgot ? (
//             <>
//               <Button variant="outlined" onClick={onClose} color="inherit">
//                 Close
//               </Button>
//               <Button onClick={() => setShowRegisterModal(true)} variant="contained" color="primary">
//                 Register
//               </Button>
//             </>
//           ) : (
//             <Button
//               onClick={() => {
//                 setShowForgot(false);
//                 setFpEmail("");
//                 setOtpSent(false);
//                 setOtpValue("");
//                 setNewPassword("");
//                 setConfirmNewPassword("");
//                 setResendTimer(0);
//                 setOtpVerified(false);
//                 setOtpGeneratedAt(null);
//                 if (otpExpiryTimerRef.current) {
//                   clearTimeout(otpExpiryTimerRef.current);
//                   otpExpiryTimerRef.current = null;
//                 }
//               }}
//               sx={{
//                 backgroundColor: "#1976d2",
//                 color: "white",
//                 fontWeight: 500,
//                 "&:hover": { backgroundColor: "#1565c0" },
//               }}
//             >
//               Back to Login
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>

//       {showRegisterModal && (
//         <RegisterModal
//           onClose={() => setShowRegisterModal(false)}
//           onRegisterSuccess={() => {
//             setShowRegisterModal(false);
//             showSnack({ severity: "success", message: "Registration successful! Please log in." });
//           }}
//         />
//       )}

//       <MessageCard
//         open={snack.open}
//         severity={snack.severity}
//         message={snack.message}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//       />
//     </>
//   );
// };

// export default LoginModal;

/// LoginModal.jsx (updated forgot/reset flow)
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff, Send } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import apiClient from "../api/axiosClient";
import RegisterModal from "./RegisterModal";
import { getUserDetails } from "../common";

const PASSWORD_RESET_ENDPOINT = "/auth/password/reset/"; // backend endpoint
const OTP_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      const t = setTimeout(() => setVisible(true), 10);
      const hide = setTimeout(() => {
        setVisible(false);
        setTimeout(() => onClose && onClose(), 300);
      }, 6000);
      return () => {
        clearTimeout(t);
        clearTimeout(hide);
      };
    } else {
      setVisible(false);
    }
  }, [open, onClose]);

  if (!open && !visible) return null;

  const palette = {
    success: {
      bg: "linear-gradient(135deg,#7ee787,#28c76f)",
      accent: "#0a7a3b",
      text: "#062b18",
    },
    error: {
      bg: "linear-gradient(135deg,#ff9a9e,#ff6b6b)",
      accent: "#660000",
      text: "#3b0f0f",
    },
    warning: {
      bg: "linear-gradient(135deg,#ffd89b,#ffb347)",
      accent: "#7a4300",
      text: "#3b2a00",
    },
    info: {
      bg: "linear-gradient(135deg,#a1c4fd,#c2e9fb)",
      accent: "#174ea6",
      text: "#07203a",
    },
  }[severity] || {
    bg: "linear-gradient(135deg,#e0e0e0,#bdbdbd)",
    accent: "#333",
    text: "#111",
  };

  const containerStyle = {
    position: "fixed",
    left: "50%",
    top: "28px",
    transform: `translateX(-50%) translateY(${visible ? "0" : "18px"})`,
    opacity: visible ? 1 : 0,
    transition: "transform 260ms cubic-bezier(.2,.9,.2,1), opacity 260ms ease",
    zIndex: 1400,
    minWidth: "260px",
    maxWidth: "92%",
    boxShadow: "0 12px 40px rgba(11,22,40,0.28)",
    borderRadius: "14px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    background: palette.bg,
    color: palette.text,
    fontFamily: "Inter, Roboto, sans-serif",
    border: `1px solid rgba(255,255,255,0.08)`,
    backdropFilter: "blur(6px)",
  };

  const iconCircle = {
    width: 42,
    height: 42,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(255,255,255,0.12)",
    flexShrink: 0,
  };

  const titleStyle = {
    fontSize: 13,
    fontWeight: 700,
    color: palette.accent,
    letterSpacing: "0.2px",
  };

  const messageStyle = {
    fontSize: 13,
    color: palette.text,
    opacity: 0.95,
    marginTop: 6,
    maxWidth: 520,
    wordBreak: "break-word",
  };

  const closeBtnStyle = {
    marginLeft: "12px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: 6,
    borderRadius: 8,
    color: "rgba(0,0,0,0.6)",
  };

  const titleMap = {
    success: "Success",
    error: "Error",
    warning: "Warning",
    info: "Info",
  };

  return (
    <div role="status" aria-live="polite" style={containerStyle}>
      <div style={iconCircle}>
        <div style={{ fontSize: 18, fontWeight: 700, color: palette.accent }}>
          {severity === "success"
            ? "✓"
            : severity === "error"
            ? "!"
            : severity === "warning"
            ? "!"
            : "i"}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <div style={titleStyle}>{titleMap[severity] || "Notice"}</div>
        <div style={messageStyle}>{message}</div>
      </div>

      <button
        aria-label="close message"
        onClick={() => {
          setVisible(false);
          setTimeout(() => onClose && onClose(), 260);
        }}
        style={closeBtnStyle}
      >
        <CloseIcon fontSize="small" />
      </button>
    </div>
  );
};

const LoginModal = ({ type, onClose, onLoginSuccess, onRegisterClick }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  // Forgot password states
  const [showForgot, setShowForgot] = useState(false);
  const [fpEmail, setFpEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  // new: otp verification & timestamps
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpGeneratedAt, setOtpGeneratedAt] = useState(null); // ms timestamp when OTP was issued
  const otpExpiryTimerRef = useRef(null);

  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  // show/hide for reset password fields
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  // remember me
  const [rememberMe, setRememberMe] = useState(false);

  // Resend timer
  const [resendTimer, setResendTimer] = useState(0);

  useEffect(() => {
    let timer = null;
    if (resendTimer > 0) {
      timer = setInterval(
        () => setResendTimer((t) => Math.max(0, t - 1)),
        1000
      );
    }
    return () => clearInterval(timer);
  }, [resendTimer]);

  // Snack state
  const [snack, setSnack] = useState({
    open: false,
    severity: "info",
    message: "",
  });
  const snackTimerRef = useRef(null);

  const showSnack = useCallback(({ severity = "info", message = "" }) => {
    if (snackTimerRef.current) {
      clearTimeout(snackTimerRef.current);
      snackTimerRef.current = null;
    }
    setSnack({ open: true, severity, message });
    snackTimerRef.current = setTimeout(() => {
      setSnack((s) => ({ ...s, open: false }));
      snackTimerRef.current = null;
    }, 6000);
  }, []);

  useEffect(() => {
    return () => {
      if (snackTimerRef.current) {
        clearTimeout(snackTimerRef.current);
        snackTimerRef.current = null;
      }
      if (otpExpiryTimerRef.current) {
        clearTimeout(otpExpiryTimerRef.current);
        otpExpiryTimerRef.current = null;
      }
    };
  }, []);

  // helper to post without auth header
  const postWithoutAuth = async (url, body) => {
    try {
      return await apiClient.post(url, body, { skipAuth: true });
    } catch (err) {
      return await apiClient.post(url, body, {
        headers: { Authorization: undefined },
      });
    }
  };

  // ---------- Login ----------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const { email, password } = formData;

    // if (email === "FIPI" && password === "FIPI") {
    //   onLoginSuccess("admin");
    //   onClose();
    //   setLoading(false);
    //   return;
    // }
    try {
      const res = await apiClient.post("/auth/login/", {
        email: formData.email,
        password: formData.password,
      });

      const { access, refresh } = res.data;
      if (access) {
        sessionStorage.setItem("access_token", access);
        sessionStorage.setItem("refresh_token", refresh || "");
        sessionStorage.setItem(
          "user_info",
          JSON.stringify(res.data.user || {})
        );
        apiClient.defaults.headers = apiClient.defaults.headers || {};
        apiClient.defaults.headers.common =
          apiClient.defaults.headers.common || {};
        apiClient.defaults.headers.common["Authorization"] = `Bearer ${access}`;
      }

      if (getUserDetails()) {
        onLoginSuccess(getUserDetails().user_role);
        onClose();
        setLoading(false);
        return;
      }

      onLoginSuccess(res.data);
      onClose();
    } catch (err) {
      const data = err.response?.data;
      const status = err.response?.status;

      if (data && typeof data === "object") {
        if (data.email) {
          showSnack({
            severity: "error",
            message: "Your user id / mail id is wrong — please check.",
          });
          setLoading(false);
          return;
        }
        if (data.password) {
          showSnack({
            severity: "error",
            message: "Password is wrong for this email — please check.",
          });
          setLoading(false);
          return;
        }
        const nf = data.non_field_errors || data.detail || data.error || null;
        if (nf) {
          const nfString = Array.isArray(nf) ? nf.join(" ") : String(nf);
          const lower = nfString.toLowerCase();
          if (
            lower.includes("unable to log in") ||
            lower.includes("no active account") ||
            lower.includes("invalid credentials") ||
            lower.includes("credentials")
          ) {
            showSnack({
              severity: "error",
              message:
                "Email or password is incorrect — please check and try again.",
            });
            setLoading(false);
            return;
          }
          showSnack({ severity: "error", message: nfString });
          setLoading(false);
          return;
        }
      }

      if (status === 401) {
        showSnack({
          severity: "error",
          message:
            "Email or password is incorrect — please check and try again.",
        });
        setLoading(false);
        return;
      }

      const fallback =
        err.response?.data?.detail || err.message || "Login failed.";
      showSnack({ severity: "error", message: `Login failed: ${fallback}` });
    } finally {
      setLoading(false);
    }
  };

  // ---------- Send OTP ----------
  const handleSendOtp = async () => {
    if (!fpEmail)
      return showSnack({
        severity: "warning",
        message: "Enter your registered email.",
      });
    setOtpLoading(true);

    try {
      // IMPORTANT: include purpose="password_reset" so backend will check user existence
      const res = await postWithoutAuth("/otp/generate/", {
        email: fpEmail.trim(),
        purpose: "password_reset",
      });

      // If we reach here, OTP was sent
      setOtpSent(true);
      setOtpValue("");
      setResendTimer(60);
      const attempts = res.data?.attempts_left;
      const blocked = res.data?.blocked_until;

      // set generated timestamp & clear any previous verification
      setOtpGeneratedAt(Date.now());
      setOtpVerified(false);
      if (otpExpiryTimerRef.current) {
        clearTimeout(otpExpiryTimerRef.current);
        otpExpiryTimerRef.current = null;
      }
      // auto-clear verification after expiry (safety)
      otpExpiryTimerRef.current = setTimeout(() => {
        setOtpVerified(false);
        otpExpiryTimerRef.current = null;
      }, OTP_EXPIRY_MS);

      let msg = `OTP sent to ${fpEmail} (expires in 5 minutes)`;
      if (attempts !== undefined) msg += ` — attempts left: ${attempts}`;
      if (blocked) msg += ` — blocked until: ${blocked}`;
      showSnack({ severity: "success", message: msg });
    } catch (err) {
      // If backend returned user_not_found (404) — show the requested message
      const status = err.response?.status;
      const data = err.response?.data;

      if (
        status === 404 &&
        (data?.detail === "user_not_found" || data?.reason === "user_not_found")
      ) {
        // Show a small pop-up telling user to register first
        showSnack({
          severity: "warning",
          message:
            "You have not registered with this email — please register first.",
        });
        // ensure we don't leave otpSent true
        setOtpSent(false);
        setOtpValue("");
        return;
      }

      const msg = friendlyErrorMessage(err);
      showSnack({ severity: "error", message: `Failed to send OTP: ${msg}` });
    } finally {
      setOtpLoading(false);
    }
  };

  // Optional: Info-only verify (does not prevent reset)
  const handleLocalVerifyOtp = async () => {
    const otp = otpValue.trim();
    if (!/^\d{6}$/.test(otp)) {
      return showSnack({
        severity: "warning",
        message: "Enter a 6-digit OTP.",
      });
    }
    setOtpLoading(true);
    try {
      const res = await postWithoutAuth("/otp/validate/", {
        email: fpEmail.trim(),
        otp,
      });

      // success => mark verified, start clearing timer to match OTP expiry
      if (res.data?.valid || res.status === 200) {
        // Ensure we have a generated timestamp; if not, treat as just-verified-now
        const generatedAt = otpGeneratedAt || Date.now();
        setOtpGeneratedAt(generatedAt);
        setOtpVerified(true);

        // clear any existing expiry timer and schedule verification clear based on original generation time
        if (otpExpiryTimerRef.current) {
          clearTimeout(otpExpiryTimerRef.current);
          otpExpiryTimerRef.current = null;
        }
        const elapsed = Date.now() - generatedAt;
        const remaining = Math.max(0, OTP_EXPIRY_MS - elapsed);
        if (remaining > 0) {
          otpExpiryTimerRef.current = setTimeout(() => {
            setOtpVerified(false);
            otpExpiryTimerRef.current = null;
          }, remaining);
        } else {
          // already expired
          setOtpVerified(false);
          showSnack({
            severity: "error",
            message: "OTP already expired — request a new one.",
          });
          setOtpLoading(false);
          return;
        }

        showSnack({
          severity: "success",
          message:
            "OTP verified — you may now reset your password (within 5 minutes).",
        });
      } else {
        showSnack({ severity: "error", message: "OTP validation failed." });
      }
    } catch (err) {
      // if validate consumes the OTP on success, doing a validate may cause reset to fail later.
      // We only use this as informational. If your backend consumes the OTP on validate, avoid calling this.
      const data = err.response?.data;
      const reason = data?.reason || JSON.stringify(data) || err.message;
      showSnack({
        severity: "error",
        message: `OTP verification failed: ${reason}`,
      });
    } finally {
      setOtpLoading(false);
    }
  };

  // ---------- Password validation ----------
  const passwordValidation = (pwd) => {
    const errors = [];
    if (!pwd || pwd.length < 6) errors.push("Minimum 6 characters");
    if (!/\d/.test(pwd)) errors.push("At least one digit required");
    if (!/[^\w\s]/.test(pwd))
      errors.push("At least one special character required");
    return {
      valid: errors.length === 0,
      message: errors.join(", "),
    };
  };

  // ---------- Reset password (direct call to reset endpoint) ----------
  const handleResetPassword = async () => {
    const otp = otpValue.trim();
    if (!fpEmail)
      return showSnack({
        severity: "warning",
        message: "Enter your registered email.",
      });
    if (!/^\d{6}$/.test(otp))
      return showSnack({
        severity: "warning",
        message: "Enter a 6-digit OTP.",
      });

    // Enforce verification + expiry check BEFORE calling reset endpoint
    if (!otpVerified) {
      return showSnack({
        severity: "warning",
        message: "Please verify the OTP first using 'Verify' button.",
      });
    }
    // check expiry relative to generation time
    if (!otpGeneratedAt || Date.now() - otpGeneratedAt > OTP_EXPIRY_MS) {
      setOtpVerified(false);
      return showSnack({
        severity: "error",
        message: "OTP expired or not found. Request a new OTP and try again.",
      });
    }

    const validation = passwordValidation(newPassword);
    if (!validation.valid) {
      return showSnack({
        severity: "warning",
        message: "Password invalid: " + validation.message,
      });
    }
    if (newPassword !== confirmNewPassword) {
      return showSnack({
        severity: "error",
        message: "Passwords do not match.",
      });
    }

    setOtpLoading(true);
    try {
      const res = await postWithoutAuth(PASSWORD_RESET_ENDPOINT, {
        email: fpEmail.trim(),
        otp,
        new_password: newPassword,
      });

      showSnack({
        severity: "success",
        message:
          res.data?.detail || "Password reset successful. Please log in.",
      });

      // reset forgot-password state
      setShowForgot(false);
      setFpEmail("");
      setOtpSent(false);
      setOtpValue("");
      setNewPassword("");
      setConfirmNewPassword("");
      setResendTimer(0);
      setOtpVerified(false);
      setOtpGeneratedAt(null);
      if (otpExpiryTimerRef.current) {
        clearTimeout(otpExpiryTimerRef.current);
        otpExpiryTimerRef.current = null;
      }
    } catch (err) {
      const data = err.response?.data;
      // helpful message for expired/not found
      if (
        data?.reason === "expired_or_not_found" ||
        (typeof data?.detail === "string" &&
          data.detail.toLowerCase().includes("expired"))
      ) {
        setOtpVerified(false);
        showSnack({
          severity: "error",
          message: "OTP expired or not found. Request a new OTP and try again.",
        });
      } else {
        const msg = friendlyErrorMessage(err, {
          notFoundHint: `Endpoint not found (404). Ensure backend implements POST ${PASSWORD_RESET_ENDPOINT}`,
        });
        showSnack({
          severity: "error",
          message: `Password reset failed: ${msg}`,
        });
      }
    } finally {
      setOtpLoading(false);
    }
  };

  function friendlyErrorMessage(err, opts = {}) {
    const status = err.response?.status;
    const data = err.response?.data;

    if (typeof data === "string") {
      const lower = data.slice(0, 200).toLowerCase();
      if (lower.includes("<!doctype") || lower.includes("<html")) {
        if (status === 404 && opts.notFoundHint) return opts.notFoundHint;
        return `Server returned HTML (status ${status || "unknown"})`;
      }
      return data.length > 300 ? data.slice(0, 300) + "..." : data;
    }

    if (data?.detail) return data.detail;
    if (data && typeof data === "object") {
      try {
        const keys = Object.keys(data);
        if (keys.length === 0) return `HTTP ${status || "error"}`;
        const first = data[keys[0]];
        if (typeof first === "string") return first;
        if (Array.isArray(first)) return first.join(" ");
        return (
          JSON.stringify(first).slice(0, 300) +
          (JSON.stringify(first).length > 300 ? "..." : "")
        );
      } catch (e) {
        return `HTTP ${status || "error"}`;
      }
    }

    return err.message || `HTTP ${status || "error"}`;
  }

  return (
    <>
      <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">
            {type === "admin" ? "Admin Login" : "User Login"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {!showForgot ? (
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{ display: "grid", gap: 2 }}
            >
              <TextField
                label="Email Address"
                variant="outlined"
                required
                fullWidth
                value={formData.email}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, email: e.target.value }))
                }
              />

              <TextField
                label="Password"
                variant="outlined"
                required
                type={showPassword ? "text" : "password"}
                fullWidth
                value={formData.password}
                onChange={(e) =>
                  setFormData((p) => ({ ...p, password: e.target.value }))
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((s) => !s)}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label
                  style={{ display: "flex", alignItems: "center", gap: 8 }}
                >
                  <input
                    type="checkbox"
                    className="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span style={{ fontSize: 14 }}>Remember me</span>
                </label>

                <Button
                  variant="text"
                  onClick={() => {
                    setShowForgot(true);
                    setFpEmail(formData.email || "");
                  }}
                >
                  Forgot password?
                </Button>
              </Box>

              <Button
                type="submit"
                variant="contained"
                color={type === "admin" ? "secondary" : "primary"}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={18} /> : null}
              >
                {loading ? "Signing In..." : "Sign In"}
              </Button>
            </Box>
          ) : (
            <Box sx={{ display: "grid", gap: 2 }}>
              <Typography variant="subtitle1">Forgot Password</Typography>

              <TextField
                label="Registered Email"
                variant="outlined"
                required
                fullWidth
                value={fpEmail}
                onChange={(e) => {
                  setFpEmail(e.target.value);
                  setOtpSent(false);
                  setOtpValue("");
                  setOtpVerified(false);
                  setOtpGeneratedAt(null);
                  if (otpExpiryTimerRef.current) {
                    clearTimeout(otpExpiryTimerRef.current);
                    otpExpiryTimerRef.current = null;
                  }
                }}
              />

              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <Button
                  variant="contained"
                  onClick={handleSendOtp}
                  disabled={otpLoading || !fpEmail || resendTimer > 0}
                  startIcon={
                    otpLoading ? <CircularProgress size={18} /> : <Send />
                  }
                >
                  {resendTimer > 0
                    ? `Resend in ${resendTimer}s`
                    : otpSent
                    ? "Resend OTP"
                    : "Send OTP"}
                </Button>

                {otpSent && (
                  <>
                    <TextField
                      label="Enter OTP"
                      variant="outlined"
                      value={otpValue}
                      onChange={(e) =>
                        setOtpValue(
                          e.target.value.replace(/\D/g, "").slice(0, 6)
                        )
                      }
                      inputProps={{ maxLength: 6 }}
                    />
                    <Button
                      variant="outlined"
                      onClick={handleLocalVerifyOtp}
                      disabled={otpLoading || otpValue.length !== 6}
                    >
                      Verify
                    </Button>
                  </>
                )}
              </Box>

              {/* Show new password fields once user entered a 6-digit OTP (so they can set new password right away) */}
              {otpValue.length === 6 && (
                <>
                  <TextField
                    label="New Password"
                    variant="outlined"
                    required
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    helperText="Min 6 chars, at least 1 digit and 1 special character"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowNewPassword((s) => !s)}
                            edge="end"
                          >
                            {showNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="Confirm New Password"
                    variant="outlined"
                    required
                    type={showConfirmNewPassword ? "text" : "password"}
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmNewPassword((s) => !s)}
                            edge="end"
                          >
                            {showConfirmNewPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                      variant="contained"
                      onClick={handleResetPassword}
                      disabled={otpLoading}
                    >
                      {otpLoading ? (
                        <CircularProgress size={18} />
                      ) : (
                        "Reset Password"
                      )}
                    </Button>
                    <Button
                      variant="text"
                      color="inherit"
                      onClick={() => {
                        setShowForgot(false);
                        setFpEmail("");
                        setOtpSent(false);
                        setOtpValue("");
                        setNewPassword("");
                        setConfirmNewPassword("");
                        setResendTimer(0);
                        setOtpVerified(false);
                        setOtpGeneratedAt(null);
                        if (otpExpiryTimerRef.current) {
                          clearTimeout(otpExpiryTimerRef.current);
                          otpExpiryTimerRef.current = null;
                        }
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>

                  {/* small verification status indicator (non-invasive) */}
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" sx={{ display: "block" }}>
                      {otpVerified
                        ? "OTP verified (valid for 5 minutes from send time)."
                        : "OTP not yet verified. Click Verify."}
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          {!showForgot ? (
            <>
              <Button variant="outlined" onClick={onClose} color="inherit">
                Close
              </Button>
              <Button
                onClick={() => setShowRegisterModal(true)}
                variant="contained"
                color="primary"
              >
                Register
              </Button>
            </>
          ) : (
            <Button
              onClick={() => {
                setShowForgot(false);
                setFpEmail("");
                setOtpSent(false);
                setOtpValue("");
                setNewPassword("");
                setConfirmNewPassword("");
                setResendTimer(0);
                setOtpVerified(false);
                setOtpGeneratedAt(null);
                if (otpExpiryTimerRef.current) {
                  clearTimeout(otpExpiryTimerRef.current);
                  otpExpiryTimerRef.current = null;
                }
              }}
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                fontWeight: 500,
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              Back to Login
            </Button>
          )}
        </DialogActions>
      </Dialog>

      {showRegisterModal && (
        <RegisterModal
          onClose={() => setShowRegisterModal(false)}
          onRegisterSuccess={() => {
            setShowRegisterModal(false);
            showSnack({
              severity: "success",
              message: "Registration successful! Please log in.",
            });
          }}
        />
      )}

      <MessageCard
        open={snack.open}
        severity={snack.severity}
        message={snack.message}
        onClose={() => setSnack((s) => ({ ...s, open: false }))}
      />
    </>
  );
};

export default LoginModal;


// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   IconButton,
//   InputAdornment,
//   Box,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { Visibility, VisibilityOff, Send } from "@mui/icons-material";
// import CloseIcon from "@mui/icons-material/Close";
// import apiClient from "../api/axiosClient";
// import RegisterModal from "./RegisterModal";
// import { getUserDetails } from "../common";

// const PASSWORD_RESET_ENDPOINT = "/auth/password/reset/"; // backend endpoint
// const OTP_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes

// const MessageCard = ({ open, severity = "info", message = "", onClose }) => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     if (open) {
//       const t = setTimeout(() => setVisible(true), 10);
//       const hide = setTimeout(() => {
//         setVisible(false);
//         setTimeout(() => onClose && onClose(), 300);
//       }, 6000);
//       return () => {
//         clearTimeout(t);
//         clearTimeout(hide);
//       };
//     } else {
//       setVisible(false);
//     }
//   }, [open, onClose]);

//   if (!open && !visible) return null;

//   const palette = {
//     success: {
//       bg: "linear-gradient(135deg,#7ee787,#28c76f)",
//       accent: "#0a7a3b",
//       text: "#062b18",
//     },
//     error: {
//       bg: "linear-gradient(135deg,#ff9a9e,#ff6b6b)",
//       accent: "#660000",
//       text: "#3b0f0f",
//     },
//     warning: {
//       bg: "linear-gradient(135deg,#ffd89b,#ffb347)",
//       accent: "#7a4300",
//       text: "#3b2a00",
//     },
//     info: {
//       bg: "linear-gradient(135deg,#a1c4fd,#c2e9fb)",
//       accent: "#174ea6",
//       text: "#07203a",
//     },
//   }[severity] || {
//     bg: "linear-gradient(135deg,#e0e0e0,#bdbdbd)",
//     accent: "#333",
//     text: "#111",
//   };

//   const containerStyle = {
//     position: "fixed",
//     left: "50%",
//     top: "28px",
//     transform: `translateX(-50%) translateY(${visible ? "0" : "18px"})`,
//     opacity: visible ? 1 : 0,
//     transition: "transform 260ms cubic-bezier(.2,.9,.2,1), opacity 260ms ease",
//     zIndex: 1400,
//     minWidth: "260px",
//     maxWidth: "92%",
//     boxShadow: "0 12px 40px rgba(11,22,40,0.28)",
//     borderRadius: "14px",
//     overflow: "hidden",
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "12px 16px",
//     background: palette.bg,
//     color: palette.text,
//     fontFamily: "Inter, Roboto, sans-serif",
//     border: `1px solid rgba(255,255,255,0.08)`,
//     backdropFilter: "blur(6px)",
//   };

//   const iconCircle = {
//     width: 42,
//     height: 42,
//     borderRadius: 10,
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     background: "rgba(255,255,255,0.12)",
//     flexShrink: 0,
//   };

//   const titleStyle = {
//     fontSize: 13,
//     fontWeight: 700,
//     color: palette.accent,
//     letterSpacing: "0.2px",
//   };

//   const messageStyle = {
//     fontSize: 13,
//     color: palette.text,
//     opacity: 0.95,
//     marginTop: 6,
//     maxWidth: 520,
//     wordBreak: "break-word",
//   };

//   const closeBtnStyle = {
//     marginLeft: "12px",
//     border: "none",
//     background: "transparent",
//     cursor: "pointer",
//     padding: 6,
//     borderRadius: 8,
//     color: "rgba(0,0,0,0.6)",
//   };

//   const titleMap = {
//     success: "Success",
//     error: "Error",
//     warning: "Warning",
//     info: "Info",
//   };

//   return (
//     <div role="status" aria-live="polite" style={containerStyle}>
//       <div style={iconCircle}>
//         <div style={{ fontSize: 18, fontWeight: 700, color: palette.accent }}>
//           {severity === "success"
//             ? "✓"
//             : severity === "error"
//             ? "!"
//             : severity === "warning"
//             ? "!"
//             : "i"}
//         </div>
//       </div>

//       <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
//         <div style={titleStyle}>{titleMap[severity] || "Notice"}</div>
//         <div style={messageStyle}>{message}</div>
//       </div>

//       <button
//         aria-label="close message"
//         onClick={() => {
//           setVisible(false);
//           setTimeout(() => onClose && onClose(), 260);
//         }}
//         style={closeBtnStyle}
//       >
//         <CloseIcon fontSize="small" />
//       </button>
//     </div>
//   );
// };

// const LoginModal = ({ type, onClose, onLoginSuccess, onRegisterClick }) => {
//   const [showPassword, setShowPassword] = useState(false);
//   const [showRegisterModal, setShowRegisterModal] = useState(false);
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [loading, setLoading] = useState(false);

//   // Forgot password states
//   const [showForgot, setShowForgot] = useState(false);
//   const [fpEmail, setFpEmail] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otpValue, setOtpValue] = useState("");
//   const [otpLoading, setOtpLoading] = useState(false);
//   // new: otp verification & timestamps
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [otpGeneratedAt, setOtpGeneratedAt] = useState(null); // ms timestamp when OTP was issued
//   const otpExpiryTimerRef = useRef(null);

//   const [newPassword, setNewPassword] = useState("");
//   const [confirmNewPassword, setConfirmNewPassword] = useState("");

//   // show/hide for reset password fields
//   const [showNewPassword, setShowNewPassword] = useState(false);
//   const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

//   // remember me
//   const [rememberMe, setRememberMe] = useState(false);

//   // Resend timer
//   const [resendTimer, setResendTimer] = useState(0);

//   useEffect(() => {
//     let timer = null;
//     if (resendTimer > 0) {
//       timer = setInterval(
//         () => setResendTimer((t) => Math.max(0, t - 1)),
//         1000
//       );
//     }
//     return () => clearInterval(timer);
//   }, [resendTimer]);

//   // Snack state
//   const [snack, setSnack] = useState({
//     open: false,
//     severity: "info",
//     message: "",
//   });
//   const snackTimerRef = useRef(null);

//   const showSnack = useCallback(({ severity = "info", message = "" }) => {
//     if (snackTimerRef.current) {
//       clearTimeout(snackTimerRef.current);
//       snackTimerRef.current = null;
//     }
//     setSnack({ open: true, severity, message });
//     snackTimerRef.current = setTimeout(() => {
//       setSnack((s) => ({ ...s, open: false }));
//       snackTimerRef.current = null;
//     }, 6000);
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (snackTimerRef.current) {
//         clearTimeout(snackTimerRef.current);
//         snackTimerRef.current = null;
//       }
//       if (otpExpiryTimerRef.current) {
//         clearTimeout(otpExpiryTimerRef.current);
//         otpExpiryTimerRef.current = null;
//       }
//     };
//   }, []);

//   // helper to post without auth header
//   const postWithoutAuth = async (url, body) => {
//     try {
//       return await apiClient.post(url, body, { skipAuth: true });
//     } catch (err) {
//       return await apiClient.post(url, body, {
//         headers: { Authorization: undefined },
//       });
//     }
//   };

//   // ---------- Login ----------
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const res = await apiClient.post("/auth/login/", {
//         email: formData.email,
//         password: formData.password,
//       });

//       const { access, refresh } = res.data;

//       // store tokens
//       if (access) {
//         sessionStorage.setItem("access_token", access);
//         sessionStorage.setItem("refresh_token", refresh || "");
//         // If backend returned full user object, store it too
//         const userObj = res.data.user || {};
//         // Extract role safely (we added user_role on backend)
//         const role =
//           (userObj && (userObj.user_role || userObj.role)) ||
//           res.data.user_role ||
//           "user";

//         // persist user info and role explicitly
//         sessionStorage.setItem("user_info", JSON.stringify(userObj));
//         sessionStorage.setItem("user_role", role);

//         // set default header for subsequent API calls
//         apiClient.defaults.headers = apiClient.defaults.headers || {};
//         apiClient.defaults.headers.common =
//           apiClient.defaults.headers.common || {};
//         apiClient.defaults.headers.common["Authorization"] = `Bearer ${access}`;
//       }

//       // Call parent's success handler with the role string to allow redirecting to /admin
//       const usedRole =
//         (res.data.user && (res.data.user.user_role || res.data.user.role)) ||
//         res.data.user_role ||
//         getUserDetails()?.user_role ||
//         "user";

//       // Always provide the role string to parent
//       onLoginSuccess(usedRole);
//       onClose();
//     } catch (err) {
//       const data = err.response?.data;
//       const status = err.response?.status;

//       if (data && typeof data === "object") {
//         if (data.email) {
//           showSnack({
//             severity: "error",
//             message: "Your user id / mail id is wrong — please check.",
//           });
//           setLoading(false);
//           return;
//         }
//         if (data.password) {
//           showSnack({
//             severity: "error",
//             message: "Password is wrong for this email — please check.",
//           });
//           setLoading(false);
//           return;
//         }
//         const nf = data.non_field_errors || data.detail || data.error || null;
//         if (nf) {
//           const nfString = Array.isArray(nf) ? nf.join(" ") : String(nf);
//           const lower = nfString.toLowerCase();
//           if (
//             lower.includes("unable to log in") ||
//             lower.includes("no active account") ||
//             lower.includes("invalid credentials") ||
//             lower.includes("credentials")
//           ) {
//             showSnack({
//               severity: "error",
//               message:
//                 "Email or password is incorrect — please check and try again.",
//             });
//             setLoading(false);
//             return;
//           }
//           showSnack({ severity: "error", message: nfString });
//           setLoading(false);
//           return;
//         }
//       }

//       if (status === 401) {
//         showSnack({
//           severity: "error",
//           message:
//             "Email or password is incorrect — please check and try again.",
//         });
//         setLoading(false);
//         return;
//       }

//       const fallback =
//         err.response?.data?.detail || err.message || "Login failed.";
//       showSnack({ severity: "error", message: `Login failed: ${fallback}` });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------- Send OTP ----------
//   const handleSendOtp = async () => {
//     if (!fpEmail)
//       return showSnack({
//         severity: "warning",
//         message: "Enter your registered email.",
//       });
//     setOtpLoading(true);

//     try {
//       // IMPORTANT: include purpose="password_reset" so backend will check user existence
//       const res = await postWithoutAuth("/otp/generate/", {
//         email: fpEmail.trim(),
//         purpose: "password_reset",
//       });

//       // If we reach here, OTP was sent
//       setOtpSent(true);
//       setOtpValue("");
//       setResendTimer(60);
//       const attempts = res.data?.attempts_left;
//       const blocked = res.data?.blocked_until;

//       // set generated timestamp & clear any previous verification
//       setOtpGeneratedAt(Date.now());
//       setOtpVerified(false);
//       if (otpExpiryTimerRef.current) {
//         clearTimeout(otpExpiryTimerRef.current);
//         otpExpiryTimerRef.current = null;
//       }
//       // auto-clear verification after expiry (safety)
//       otpExpiryTimerRef.current = setTimeout(() => {
//         setOtpVerified(false);
//         otpExpiryTimerRef.current = null;
//       }, OTP_EXPIRY_MS);

//       let msg = `OTP sent to ${fpEmail} (expires in 5 minutes)`;
//       if (attempts !== undefined) msg += ` — attempts left: ${attempts}`;
//       if (blocked) msg += ` — blocked until: ${blocked}`;
//       showSnack({ severity: "success", message: msg });
//     } catch (err) {
//       // If backend returned user_not_found (404) — show the requested message
//       const status = err.response?.status;
//       const data = err.response?.data;

//       if (
//         status === 404 &&
//         (data?.detail === "user_not_found" || data?.reason === "user_not_found")
//       ) {
//         // Show a small pop-up telling user to register first
//         showSnack({
//           severity: "warning",
//           message:
//             "You have not registered with this email — please register first.",
//         });
//         // ensure we don't leave otpSent true
//         setOtpSent(false);
//         setOtpValue("");
//         return;
//       }

//       const msg = friendlyErrorMessage(err);
//       showSnack({ severity: "error", message: `Failed to send OTP: ${msg}` });
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   // Optional: Info-only verify (does not prevent reset)
//   const handleLocalVerifyOtp = async () => {
//     const otp = otpValue.trim();
//     if (!/^\d{6}$/.test(otp)) {
//       return showSnack({
//         severity: "warning",
//         message: "Enter a 6-digit OTP.",
//       });
//     }
//     setOtpLoading(true);
//     try {
//       const res = await postWithoutAuth("/otp/validate/", {
//         email: fpEmail.trim(),
//         otp,
//       });

//       // success => mark verified, start clearing timer to match OTP expiry
//       if (res.data?.valid || res.status === 200) {
//         // Ensure we have a generated timestamp; if not, treat as just-verified-now
//         const generatedAt = otpGeneratedAt || Date.now();
//         setOtpGeneratedAt(generatedAt);
//         setOtpVerified(true);

//         // clear any existing expiry timer and schedule verification clear based on original generation time
//         if (otpExpiryTimerRef.current) {
//           clearTimeout(otpExpiryTimerRef.current);
//           otpExpiryTimerRef.current = null;
//         }
//         const elapsed = Date.now() - generatedAt;
//         const remaining = Math.max(0, OTP_EXPIRY_MS - elapsed);
//         if (remaining > 0) {
//           otpExpiryTimerRef.current = setTimeout(() => {
//             setOtpVerified(false);
//             otpExpiryTimerRef.current = null;
//           }, remaining);
//         } else {
//           // already expired
//           setOtpVerified(false);
//           showSnack({
//             severity: "error",
//             message: "OTP already expired — request a new one.",
//           });
//           setOtpLoading(false);
//           return;
//         }

//         showSnack({
//           severity: "success",
//           message:
//             "OTP verified — you may now reset your password (within 5 minutes).",
//         });
//       } else {
//         showSnack({ severity: "error", message: "OTP validation failed." });
//       }
//     } catch (err) {
//       // if validate consumes the OTP on success, doing a validate may cause reset to fail later.
//       // We only use this as informational. If your backend consumes the OTP on validate, avoid calling this.
//       const data = err.response?.data;
//       const reason = data?.reason || JSON.stringify(data) || err.message;
//       showSnack({
//         severity: "error",
//         message: `OTP verification failed: ${reason}`,
//       });
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   // ---------- Password validation ----------
//   const passwordValidation = (pwd) => {
//     const errors = [];
//     if (!pwd || pwd.length < 6) errors.push("Minimum 6 characters");
//     if (!/\d/.test(pwd)) errors.push("At least one digit required");
//     if (!/[^\w\s]/.test(pwd))
//       errors.push("At least one special character required");
//     return {
//       valid: errors.length === 0,
//       message: errors.join(", "),
//     };
//   };

//   // ---------- Reset password (direct call to reset endpoint) ----------
//   const handleResetPassword = async () => {
//     const otp = otpValue.trim();
//     if (!fpEmail)
//       return showSnack({
//         severity: "warning",
//         message: "Enter your registered email.",
//       });
//     if (!/^\d{6}$/.test(otp))
//       return showSnack({
//         severity: "warning",
//         message: "Enter a 6-digit OTP.",
//       });

//     // Enforce verification + expiry check BEFORE calling reset endpoint
//     if (!otpVerified) {
//       return showSnack({
//         severity: "warning",
//         message: "Please verify the OTP first using 'Verify' button.",
//       });
//     }
//     // check expiry relative to generation time
//     if (!otpGeneratedAt || Date.now() - otpGeneratedAt > OTP_EXPIRY_MS) {
//       setOtpVerified(false);
//       return showSnack({
//         severity: "error",
//         message: "OTP expired or not found. Request a new OTP and try again.",
//       });
//     }

//     const validation = passwordValidation(newPassword);
//     if (!validation.valid) {
//       return showSnack({
//         severity: "warning",
//         message: "Password invalid: " + validation.message,
//       });
//     }
//     if (newPassword !== confirmNewPassword) {
//       return showSnack({
//         severity: "error",
//         message: "Passwords do not match.",
//       });
//     }

//     setOtpLoading(true);
//     try {
//       const res = await postWithoutAuth(PASSWORD_RESET_ENDPOINT, {
//         email: fpEmail.trim(),
//         otp,
//         new_password: newPassword,
//       });

//       showSnack({
//         severity: "success",
//         message:
//           res.data?.detail || "Password reset successful. Please log in.",
//       });

//       // reset forgot-password state
//       setShowForgot(false);
//       setFpEmail("");
//       setOtpSent(false);
//       setOtpValue("");
//       setNewPassword("");
//       setConfirmNewPassword("");
//       setResendTimer(0);
//       setOtpVerified(false);
//       setOtpGeneratedAt(null);
//       if (otpExpiryTimerRef.current) {
//         clearTimeout(otpExpiryTimerRef.current);
//         otpExpiryTimerRef.current = null;
//       }
//     } catch (err) {
//       const data = err.response?.data;
//       // helpful message for expired/not found
//       if (
//         data?.reason === "expired_or_not_found" ||
//         (typeof data?.detail === "string" &&
//           data.detail.toLowerCase().includes("expired"))
//       ) {
//         setOtpVerified(false);
//         showSnack({
//           severity: "error",
//           message: "OTP expired or not found. Request a new OTP and try again.",
//         });
//       } else {
//         const msg = friendlyErrorMessage(err, {
//           notFoundHint: `Endpoint not found (404). Ensure backend implements POST ${PASSWORD_RESET_ENDPOINT}`,
//         });
//         showSnack({
//           severity: "error",
//           message: `Password reset failed: ${msg}`,
//         });
//       }
//     } finally {
//       setOtpLoading(false);
//     }
//   };

//   function friendlyErrorMessage(err, opts = {}) {
//     const status = err.response?.status;
//     const data = err.response?.data;

//     if (typeof data === "string") {
//       const lower = data.slice(0, 200).toLowerCase();
//       if (lower.includes("<!doctype") || lower.includes("<html")) {
//         if (status === 404 && opts.notFoundHint) return opts.notFoundHint;
//         return `Server returned HTML (status ${status || "unknown"})`;
//       }
//       return data.length > 300 ? data.slice(0, 300) + "..." : data;
//     }

//     if (data?.detail) return data.detail;
//     if (data && typeof data === "object") {
//       try {
//         const keys = Object.keys(data);
//         if (keys.length === 0) return `HTTP ${status || "error"}`;
//         const first = data[keys[0]];
//         if (typeof first === "string") return first;
//         if (Array.isArray(first)) return first.join(" ");
//         return (
//           JSON.stringify(first).slice(0, 300) +
//           (JSON.stringify(first).length > 300 ? "..." : "")
//         );
//       } catch (e) {
//         return `HTTP ${status || "error"}`;
//       }
//     }

//     return err.message || `HTTP ${status || "error"}`;
//   }

//   return (
//     <>
//       <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
//         <DialogTitle
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//           }}
//         >
//           <Typography variant="h6">
//             {type === "admin" ? "Admin Login" : "User Login"}
//           </Typography>
//           <IconButton onClick={onClose}>
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent dividers>
//           {!showForgot ? (
//             <Box
//               component="form"
//               onSubmit={handleSubmit}
//               sx={{ display: "grid", gap: 2 }}
//             >
//               <TextField
//                 label="Email Address"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={formData.email}
//                 onChange={(e) =>
//                   setFormData((p) => ({ ...p, email: e.target.value }))
//                 }
//               />

//               <TextField
//                 label="Password"
//                 variant="outlined"
//                 required
//                 type={showPassword ? "text" : "password"}
//                 fullWidth
//                 value={formData.password}
//                 onChange={(e) =>
//                   setFormData((p) => ({ ...p, password: e.target.value }))
//                 }
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setShowPassword((s) => !s)}
//                         edge="end"
//                       >
//                         {showPassword ? <VisibilityOff /> : <Visibility />}
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />

//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                 }}
//               >
//                 <label
//                   style={{ display: "flex", alignItems: "center", gap: 8 }}
//                 >
//                   <input
//                     type="checkbox"
//                     className="checkbox"
//                     checked={rememberMe}
//                     onChange={(e) => setRememberMe(e.target.checked)}
//                   />
//                   <span style={{ fontSize: 14 }}>Remember me</span>
//                 </label>

//                 <Button
//                   variant="text"
//                   onClick={() => {
//                     setShowForgot(true);
//                     setFpEmail(formData.email || "");
//                   }}
//                 >
//                   Forgot password?
//                 </Button>
//               </Box>

//               <Button
//                 type="submit"
//                 variant="contained"
//                 color={type === "admin" ? "secondary" : "primary"}
//                 disabled={loading}
//                 startIcon={loading ? <CircularProgress size={18} /> : null}
//               >
//                 {loading ? "Signing In..." : "Sign In"}
//               </Button>
//             </Box>
//           ) : (
//             <Box sx={{ display: "grid", gap: 2 }}>
//               <Typography variant="subtitle1">Forgot Password</Typography>

//               <TextField
//                 label="Registered Email"
//                 variant="outlined"
//                 required
//                 fullWidth
//                 value={fpEmail}
//                 onChange={(e) => {
//                   setFpEmail(e.target.value);
//                   setOtpSent(false);
//                   setOtpValue("");
//                   setOtpVerified(false);
//                   setOtpGeneratedAt(null);
//                   if (otpExpiryTimerRef.current) {
//                     clearTimeout(otpExpiryTimerRef.current);
//                     otpExpiryTimerRef.current = null;
//                   }
//                 }}
//               />

//               <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//                 <Button
//                   variant="contained"
//                   onClick={handleSendOtp}
//                   disabled={otpLoading || !fpEmail || resendTimer > 0}
//                   startIcon={
//                     otpLoading ? <CircularProgress size={18} /> : <Send />
//                   }
//                 >
//                   {resendTimer > 0
//                     ? `Resend in ${resendTimer}s`
//                     : otpSent
//                     ? "Resend OTP"
//                     : "Send OTP"}
//                 </Button>

//                 {otpSent && (
//                   <>
//                     <TextField
//                       label="Enter OTP"
//                       variant="outlined"
//                       value={otpValue}
//                       onChange={(e) =>
//                         setOtpValue(
//                           e.target.value.replace(/\D/g, "").slice(0, 6)
//                         )
//                       }
//                       inputProps={{ maxLength: 6 }}
//                     />
//                     <Button
//                       variant="outlined"
//                       onClick={handleLocalVerifyOtp}
//                       disabled={otpLoading || otpValue.length !== 6}
//                     >
//                       Verify
//                     </Button>
//                   </>
//                 )}
//               </Box>

//               {/* Show new password fields once user entered a 6-digit OTP (so they can set new password right away) */}
//               {otpValue.length === 6 && (
//                 <>
//                   <TextField
//                     label="New Password"
//                     variant="outlined"
//                     required
//                     type={showNewPassword ? "text" : "password"}
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     helperText="Min 6 chars, at least 1 digit and 1 special character"
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={() => setShowNewPassword((s) => !s)}
//                             edge="end"
//                           >
//                             {showNewPassword ? (
//                               <VisibilityOff />
//                             ) : (
//                               <Visibility />
//                             )}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                   <TextField
//                     label="Confirm New Password"
//                     variant="outlined"
//                     required
//                     type={showConfirmNewPassword ? "text" : "password"}
//                     value={confirmNewPassword}
//                     onChange={(e) => setConfirmNewPassword(e.target.value)}
//                     InputProps={{
//                       endAdornment: (
//                         <InputAdornment position="end">
//                           <IconButton
//                             onClick={() => setShowConfirmNewPassword((s) => !s)}
//                             edge="end"
//                           >
//                             {showConfirmNewPassword ? (
//                               <VisibilityOff />
//                             ) : (
//                               <Visibility />
//                             )}
//                           </IconButton>
//                         </InputAdornment>
//                       ),
//                     }}
//                   />

//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <Button
//                       variant="contained"
//                       onClick={handleResetPassword}
//                       disabled={otpLoading}
//                     >
//                       {otpLoading ? (
//                         <CircularProgress size={18} />
//                       ) : (
//                         "Reset Password"
//                       )}
//                     </Button>
//                     <Button
//                       variant="text"
//                       color="inherit"
//                       onClick={() => {
//                         setShowForgot(false);
//                         setFpEmail("");
//                         setOtpSent(false);
//                         setOtpValue("");
//                         setNewPassword("");
//                         setConfirmNewPassword("");
//                         setResendTimer(0);
//                         setOtpVerified(false);
//                         setOtpGeneratedAt(null);
//                         if (otpExpiryTimerRef.current) {
//                           clearTimeout(otpExpiryTimerRef.current);
//                           otpExpiryTimerRef.current = null;
//                         }
//                       }}
//                     >
//                       Cancel
//                     </Button>
//                   </Box>

//                   {/* small verification status indicator (non-invasive) */}
//                   <Box sx={{ mt: 1 }}>
//                     <Typography variant="caption" sx={{ display: "block" }}>
//                       {otpVerified
//                         ? "OTP verified (valid for 5 minutes from send time)."
//                         : "OTP not yet verified. Click Verify."}
//                     </Typography>
//                   </Box>
//                 </>
//               )}
//             </Box>
//           )}
//         </DialogContent>

//         <DialogActions sx={{ px: 3, py: 2 }}>
//           {!showForgot ? (
//             <>
//               <Button variant="outlined" onClick={onClose} color="inherit">
//                 Close
//               </Button>
//               <Button
//                 onClick={() => setShowRegisterModal(true)}
//                 variant="contained"
//                 color="primary"
//               >
//                 Register
//               </Button>
//             </>
//           ) : (
//             <Button
//               onClick={() => {
//                 setShowForgot(false);
//                 setFpEmail("");
//                 setOtpSent(false);
//                 setOtpValue("");
//                 setNewPassword("");
//                 setConfirmNewPassword("");
//                 setResendTimer(0);
//                 setOtpVerified(false);
//                 setOtpGeneratedAt(null);
//                 if (otpExpiryTimerRef.current) {
//                   clearTimeout(otpExpiryTimerRef.current);
//                   otpExpiryTimerRef.current = null;
//                 }
//               }}
//               sx={{
//                 backgroundColor: "#1976d2",
//                 color: "white",
//                 fontWeight: 500,
//                 "&:hover": { backgroundColor: "#1565c0" },
//               }}
//             >
//               Back to Login
//             </Button>
//           )}
//         </DialogActions>
//       </Dialog>

//       {showRegisterModal && (
//         <RegisterModal
//           onClose={() => setShowRegisterModal(false)}
//           onRegisterSuccess={() => {
//             setShowRegisterModal(false);
//             showSnack({
//               severity: "success",
//               message: "Registration successful! Please log in.",
//             });
//           }}
//         />
//       )}

//       <MessageCard
//         open={snack.open}
//         severity={snack.severity}
//         message={snack.message}
//         onClose={() => setSnack((s) => ({ ...s, open: false }))}
//       />
//     </>
//   );
// };

// export default LoginModal;
